import React, { useEffect, useRef, useState } from 'react';
import SpotComp from './SoptCom';
import { StopListItem } from '../../utils/formatType';
import ScheduleModel from '../ScheduleModel/SchedulemModel';
import { getPermissionById } from '@/utils';
import { CLSTAG, PermissionButton } from '@/utils/constant';
import { clstagStr } from '@/utils/util';

interface StopItemProps extends StopListItem {
  vehicleId: any;
  hasProcessLine: boolean;
  isFirstOrLast: boolean;
  isLast: boolean;
  handleClick: AnyFunc;
  handleScheduleModel: AnyFunc;
}
const StopItem = (props: StopItemProps) => {
  const StopRef = useRef<HTMLDivElement>(null);
  const {
    vehicleId,
    hasProcessLine,
    travelStatus,
    time,
    isFirstOrLast,
    percent,
    isLast,
    goalId,
    stopAction,
    handleClick,
    handleScheduleModel,
  } = props;
  const [visible, setVisible] = useState(false);
  const handleClickStop = isFirstOrLast
    ? handleClick.bind(null, null, stopAction)
    : handleClick.bind(null, goalId, stopAction);
  const showScheuleModel = (e: any) => {
    const scheduleDetailPermission = getPermissionById(
      PermissionButton.SPV_SCHEDULE_DETAIL,
    );
    if (!scheduleDetailPermission) {
      return;
    }
    handleScheduleModel();
  };
  return (
    <>
      <div
        className={`stop-item ${!hasProcessLine ? 'stop-item-first' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
        ref={StopRef}
      >
        {hasProcessLine && (
          <span
            className='process-line-wrapper'
            onClick={showScheuleModel}
            clstag={clstagStr(CLSTAG.MultiPage_ScheduleModal)}
          >
            <span className='default-line'></span>
            <span
              className='process-line'
              style={{
                width: `${hasProcessLine ? percent : 0}%`,
              }}
            ></span>
          </span>
        )}
        <SpotComp
          travelStatus={travelStatus}
          time={time}
          isFirstOrLast={isFirstOrLast}
          isLast={isLast}
          handleClick={handleClickStop}
        />
      </div>
    </>
  );
};

export default React.memo(StopItem);
